import React from 'react';
import { Paper } from '@material-ui/core';
import { LocationOn } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

import { useConnect } from './hooks';
import messages from './messages';
import { usePageView } from '../../../../hooks/analytics';
import { RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM, eventTags } from '../../../../services/analytics/tags';
import piwik from '../../../../services/analytics';

import Page from '../../../../components/Page';
import Title from '../../../../components/Title';
import Footer from '../../../../components/Footer';
import Button from '../../../../components/Button';
import Field from '../../../../components/Field';
import Typography from '../../../../components/Typography';

const useStyles = makeStyles(() => ({
  paper: {
    padding: '16px',
    margin: '16px',
  },
  title: {
    marginTop: '16px',
    fontSize: '24px',
    fontWeight: 'bold',
  },
  content: {
    flex: 1,
    position: 'relative',
  },
  subtitle: {
    marginBottom: '10px',
  },
}));

const RentalVehicleLocationGarageConfirm = () => {
  usePageView(RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM);

  const classes = useStyles();

  const {
    currentGarageName,
    currentGarageAddress,
    vehicleDestinationName,
    vehicleDestinationAddress,
    vehicleGarageLocationCorrect,
    next,
  } = useConnect();

  return (
    <Page name="rentalVehicleLocation" direction="column">
      <div className={classes.content}>
        <Title content={messages.title} titleStyle={classes.title} src="carPark" size="64" />
        <Paper className={classes.paper}>
          <Typography
            className={classes.subtitle}
            align="left"
            content={currentGarageName || vehicleDestinationName}
            variant="subtitle1"
          />
          <Field
            name="garageAddress"
            content={currentGarageAddress || vehicleDestinationAddress}
            iconAnchorId="dropOffAreaIcon"
            icon={LocationOn}
            iconColor="primary"
          />
        </Paper>
      </div>

      <Footer direction="column">
        <Button
          name="yes"
          content={messages.confirmAddressButton}
          onClick={() => {
            piwik.trackEvent(eventTags.rental_vehicle_location_garage_confirm);
            vehicleGarageLocationCorrect();
          }}
        />
        <Button
          name="no"
          content={messages.cancelAddressButton}
          variant="outlined"
          onClick={() => {
            piwik.trackEvent(eventTags.rental_vehicle_location_garage_cancel);
            next();
          }}
        />
      </Footer>
    </Page>
  );
};

export default RentalVehicleLocationGarageConfirm;
